import 'twin.macro';

import imgBlueBar from '../../assets/images/blue-bar.png';
import imgBlueBarMobile from '../../assets/images/blue-bar_mobile.png';
import imgCard1 from '../../assets/images/card1.png';
import imgCard2 from '../../assets/images/card2.png';
import iconTrophy1 from '../../assets/svgs/trophy1.svg';
import iconTrophy2 from '../../assets/svgs/trophy2.svg';
import iconTrophy3 from '../../assets/svgs/trophy3.svg';
import iconTrophy4 from '../../assets/svgs/trophy4.svg';

const CardWaveSection = () => {
  return (
    <div
      css={{
        backgroundImage: 'url(/nft-hunt/images/wave-part-bg.jpg)',
      }}
      tw="pt-[563.3333%] md:pt-[126.81%] relative w-full flex flex-col bg-no-repeat bg-center bg-cover"
    >
      <div tw="absolute left-0 top-0 w-full h-full">
        <img
          alt="blue bar"
          src={imgBlueBarMobile}
          tw="block md:hidden w-full translate-y-[-35%]"
        />
        <img
          alt="blue bar"
          src={imgBlueBar}
          tw="hidden md:block w-full translate-y-[-35%]"
        />
        <div tw="mx-auto pt-[18vw] md:pt-[6vw] w-full max-w-[70.21vw] flex flex-col md:flex-row gap-[14vw] md:gap-0 justify-between items-center">
          <div tw="max-w-[80vw] md:max-w-[31.73vw] font-normal font-lumadFree text-[6vw] md:text-[2.2vw] text-center leading-[130%] tracking-normal">
            A hunt to find NFTs...
          </div>
          <img alt="card1" src={imgCard1} tw="w-[85vw] md:w-[32.22vw]" />
        </div>
        <div tw="mx-auto pt-[18vw] md:pt-[6vw] pb-[6vw] w-full max-w-[70.21vw] flex flex-col-reverse md:flex-row gap-[14vw] md:gap-0 justify-between items-center">
          <img alt="card2" src={imgCard2} tw="w-[85vw] md:w-[32.22vw]" />
          <div tw="max-w-[65vw] md:max-w-[34.51vw] font-normal font-lumadFree text-[6vw] md:text-[2.2vw] text-center leading-[130%] tracking-normal">
            Teams that find the most...
          </div>
        </div>
        <div
          css={{ backgroundImage: 'url(/nft-hunt/images/wave.png)' }}
          tw="relative pt-[72vw] md:pt-[20.63vw] w-full bg-no-repeat bg-center bg-cover"
        >
          <div tw="absolute max-w-[80vw] md:max-w-[66.6vw] left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] font-normal font-lumadFree text-[6vw] md:text-[2.8vw] text-center leading-[120%] md:leading-[130%] tracking-normal">
            win{' '}
            <span tw="inline text-[6vw] md:text-[2.8vw] whitespace-nowrap leading-[120%] md:leading-[130%] tracking-normal">
              the biggest
            </span>{' '}
            prizes!
          </div>
        </div>
        <div tw="mx-auto pt-[22vw] md:pt-[3vw] max-w-[85vw] md:max-w-[34.93vw] font-normal font-lumadFree text-[5vw] md:text-[1.6vw] text-center leading-[130%] tracking-normal">
          And the huge Jackpot Bonuses?
        </div>
        <div tw="mx-auto pt-[7vw] md:pt-[1vw] max-w-[79vw] md:max-w-[37.78vw] text-center text-[4vw] md:text-[1.14vw] leading-[130%]">
          100% of buy-in money goes back to players in a variety of Jackpot
          competitions:
        </div>
        <div tw="mx-auto pt-[18vw] md:pt-[4vw] w-full max-w-[73.40vw] flex flex-col md:flex-row justify-between items-center md:items-start gap-[10vw] md:gap-0">
          <div tw="flex flex-col items-center">
            <div tw="w-[20.51vw] md:w-[5.56vw] h-[20.51vw] md:h-[5.56vw] flex justify-center items-center bg-[rgba(255, 255, 255, 0.1)]">
              <img alt="" src={iconTrophy1} tw="w-[10vw] md:w-[2.56vw]" />
            </div>
            <div tw="pt-[6vw] md:pt-[1vw] w-full max-w-[70vw] md:max-w-[18vw] text-[4vw] md:text-[1.2vw] leading-[130%] text-center text-white">
              Rarest NFTs found Round 1
            </div>
          </div>
          <div tw="flex flex-col items-center">
            <div tw="w-[20.51vw] md:w-[5.56vw] h-[20.51vw] md:h-[5.56vw] flex justify-center items-center bg-[rgba(255, 255, 255, 0.1)]">
              <img alt="" src={iconTrophy2} tw="w-[10vw] md:w-[2.56vw]" />
            </div>
            <div tw="pt-[6vw] md:pt-[1vw] w-full max-w-[70vw] md:max-w-[18vw] text-[4vw] md:text-[1.2vw] leading-[130%] text-center text-white">
              Rarest NFTs found Finals
            </div>
          </div>
          <div tw="flex flex-col items-center">
            <div tw="w-[20.51vw] md:w-[5.56vw] h-[20.51vw] md:h-[5.56vw] flex justify-center items-center bg-[rgba(255, 255, 255, 0.1)]">
              <img alt="" src={iconTrophy3} tw="w-[10vw] md:w-[2.56vw]" />
            </div>
            <div tw="pt-[6vw] md:pt-[1vw] w-full max-w-[70vw] md:max-w-[18vw] text-[4vw] md:text-[1.2vw] leading-[130%] text-center text-white">
              Best reaction finding NFT (voted by community)
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardWaveSection;
